var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['process-content', 'process-editor', 'layout_type_1']
  }, [_c('ProcessTop', {
    attrs: {
      "readOnly": true
    }
  }), _c('div', {
    ref: "topPanel",
    staticClass: "topPanel"
  }, [_c('IssueList'), _c('ReadOnlyEditor'), _c('SideBar')], 1), _c('div', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable",
      value: {
        target: 'topPanel'
      },
      expression: "{ target: 'topPanel' }"
    }],
    staticClass: "divider"
  }, [_c('div', {
    staticClass: "divider_btn"
  })]), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }